import React          from 'react';
import { makeStyles } from "makeStyles";




const useStyles = makeStyles()(
    (theme) => ({
    root: {
        marginRight:     10,
        display:         'flex',
        alignItems:      'center',
        justifyContent:  'center',
        borderRadius:    '0.4em',
        fontWeight:      'bold',
        backgroundColor: theme.darkBlue,
        color:           '#FFF',
        cursor:          'pointer',
        '&:hover': {
          backgroundColor: theme.blue,
        }
      }
  })
);

type MenuButtonsProps = {
  menuSize:     number;
  text:         string;
  wideScreen:   boolean;
  handleClick:  () => void;
}

const MenuButtons: React.FC<MenuButtonsProps> = ({ 
  menuSize, 
  text,
  wideScreen,
  handleClick 
}) => {

  const { classes } = useStyles();

  const rootStyle = React.useMemo(() => {
    return {
        width:       wideScreen ? menuSize - 20 : 120,
        height:      wideScreen ? 40 : 30,
        marginTop:   wideScreen ? 10 : 15,
    }
  },[menuSize, wideScreen])

  return (
     <div 
       dir       = 'rtl'
       className = { classes.root }
       style     = { rootStyle }
       onClick   = { handleClick }
     >
       { text }
     </div>
  );
}



export default MenuButtons;








